/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  AssociateCashDrawerBodyBody,
  BadRequestResponse,
  DissociateCashDrawerBodyBody,
  FailureResponseResponse,
  ForbiddenResponse,
  SuccessResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Dissociate a Cash Drawer and Counter
 */
export const dissociationCashDrawer = (
  dissociateCashDrawerBodyBody: DissociateCashDrawerBodyBody,
) => {
  return customInstance<SuccessResponse>({
    url: `/bm-accounting-location/v1/dissociation`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: dissociateCashDrawerBodyBody,
  });
};

export const getDissociationCashDrawerMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dissociationCashDrawer>>,
    TError,
    { data: DissociateCashDrawerBodyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dissociationCashDrawer>>,
  TError,
  { data: DissociateCashDrawerBodyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dissociationCashDrawer>>,
    { data: DissociateCashDrawerBodyBody }
  > = (props) => {
    const { data } = props ?? {};

    return dissociationCashDrawer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DissociationCashDrawerMutationResult = NonNullable<
  Awaited<ReturnType<typeof dissociationCashDrawer>>
>;
export type DissociationCashDrawerMutationBody = DissociateCashDrawerBodyBody;
export type DissociationCashDrawerMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
>;

/**
 * @summary Dissociate a Cash Drawer and Counter
 */
export const useDissociationCashDrawer = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dissociationCashDrawer>>,
    TError,
    { data: DissociateCashDrawerBodyBody },
    TContext
  >;
}) => {
  const mutationOptions = getDissociationCashDrawerMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary (From Counter) Dissociate a Cash Drawer and Counter
 */
export const dissociationCashDrawerCounter = (
  associateCashDrawerBodyBody: AssociateCashDrawerBodyBody,
) => {
  return customInstance<SuccessResponse>({
    url: `/bm-accounting-location/v1/dissociation-counter`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: associateCashDrawerBodyBody,
  });
};

export const getDissociationCashDrawerCounterMutationOptions = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dissociationCashDrawerCounter>>,
    TError,
    { data: AssociateCashDrawerBodyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dissociationCashDrawerCounter>>,
  TError,
  { data: AssociateCashDrawerBodyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dissociationCashDrawerCounter>>,
    { data: AssociateCashDrawerBodyBody }
  > = (props) => {
    const { data } = props ?? {};

    return dissociationCashDrawerCounter(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DissociationCashDrawerCounterMutationResult = NonNullable<
  Awaited<ReturnType<typeof dissociationCashDrawerCounter>>
>;
export type DissociationCashDrawerCounterMutationBody = AssociateCashDrawerBodyBody;
export type DissociationCashDrawerCounterMutationError = ErrorType<
  BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
>;

/**
 * @summary (From Counter) Dissociate a Cash Drawer and Counter
 */
export const useDissociationCashDrawerCounter = <
  TError = ErrorType<
    BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dissociationCashDrawerCounter>>,
    TError,
    { data: AssociateCashDrawerBodyBody },
    TContext
  >;
}) => {
  const mutationOptions = getDissociationCashDrawerCounterMutationOptions(options);

  return useMutation(mutationOptions);
};
